import {
    /** FETCH APPLICATION  */
    FETCH_PAGINGAPPLICATIONNURSE_FULFILLED,
    FETCH_PAGINGAPPLICATIONNURSE_REJECTED,
    FETCH_PAGINGAPPLICATIONNURSE_PENDING,
    RESET_PAGINGAPPLICATIONNURSE
} from "../../actions/nurse/pagingApplicationNurse";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PAGINGAPPLICATIONNURSE_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_PAGINGAPPLICATIONNURSE_FULFILLED:
            return {
                ...state,
                pagingApplicationNurse: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_PAGINGAPPLICATIONNURSE_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_PAGINGAPPLICATIONNURSE:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};